import PropTypes from 'prop-types';
import styled from 'styled-components';

const ProductTitle = styled.header`
  .resultGrid & {
    height: 50px;
    overflow: hidden;
    font-size: 14px;
    font-weight: normal;
    color: #161b7a;

    @media ${({ theme }) => theme.breakpoints.desktop} {
      font-size: 15px !important;
      height: 55px;
    }
  }

  .resultGrid .product:hover & {
    text-decoration: underline;
  }

  .resultList .stamped & {
    vertical-align: top;
    width: calc(100% - 60px);
    padding-left: 60px;
  }

  .resultList & {
    font-size: 16px;
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 60px);
    box-sizing: content-box;

    a {
      font-weight: normal;
      color: #4855a0;

      &:hover {
        text-decoration: underline;
      }

      &:after {
        display: inline-block;
        visibility: hidden;
        margin-right: 5px;
        font-family: 'dcg-icons';
        content: '\e601';
      }
    }

    @media ${({ theme }) => theme.breakpoints.mobileMin} {
      margin-bottom: 20px;
      font-size: 16px;
    }
  }

  .resultList .desc {
    &:hover,
    &:focus {
      & {
        text-decoration: underline;

        &:after {
          visibility: visible;
        }
      }
    }
  }
`;

const ProductItemTitle = ({ onClick, brand, title, link }) => (
  <ProductTitle onClick={onClick} className={'productTitle'}>
    {link ? (
      <a href={link}>
        <span data-product={'brand'}>
          {brand.title}
          {' '}
        </span>
        <span data-product={'name'}>{title}</span>
      </a>
    ) : (
      <>
        <span data-product={'brand'}>
          {brand.title}
          {' '}
        </span>
        <span data-product={'name'}>{title}</span>
      </>
    )}
  </ProductTitle>
);

ProductItemTitle.propTypes = {
  onClick: PropTypes.func,
  brand: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string
};

ProductItemTitle.defaultProps = {
  onClick: () => {},
  link: undefined
};

export default ProductItemTitle;
